module.exports = __webpack_public_path__ + "img/mofang.8b10b2d4.jpg";